import React from 'react';
import { Typography, Button, Link } from '@one-thd/sui-atomic-components';
import data from './data';

const logoSrc = 'https://dam.thdstatic.com/content/production/PKmihV6ZCuiWm7V0wc8GUA/'
  + 'qM92ay55VDz-Daw1jzBI4A/Original file/Eco_Actions_Logo.jpg';
const qrSrc = 'https://dam.thdstatic.com/content/production/77nb9JRVTuvBsqcs1JVykQ/'
  + 'jc5pHtrbyBQy1sGdTd4cBw/Original file/Recycling_Eco_Actions_QRcode.jpg';

export const PPSMainRecycling = () => {
  return (
    <div className="sui-p-6 sui-flex sui-flex-col sui-items-start sui-gap-6 sui-bg-primary">
      <Typography variant="h2" weight="bold" className="sui-text-left sui-mb-12 ">
        Recycling at The Home Depot
      </Typography>

      <div
        className="sui-grid sui-grid-cols-1 md:sui-grid-cols-3 sui-gap-10 sui-mb-2 sui-px-2
          md:sui-px-4 sui-place-items-center"
      >
        {data.map(({ title, content, imageUrl, commonProducts }, idx) => (
          <div
            key={title || idx}
            className="sui-w-full sui-h-auto md:sui-h-full sui-rounded-lg sui-overflow-hidden sui-flex
            sui-flex-col sui-px-4 sui-py-4 sui-bg-brand sui-justify-between"
          >
            <div className="sui-flex sui-items-center sui-justify-center sui-h-18 sm:sui-h-20
            md:sui-h-24 sui-text-center"
            >
              <Typography
                variant="h4"
                weight="bold"
                color="inverse"
                className="sui-w-full sui-whitespace-pre-line sui-leading-tight"
              >
                {title}
              </Typography>
            </div>

            <hr className="sui-w-3/4 sui-h-px sui-border-t sui-border-white sui-my-0 sui-mx-auto" />

            <div className="sui-flex sui-items-center sui-justify-center sui-text-center sui-py-2">
              <Typography
                variant="body-lg"
                weight="bold"
                color="inverse"
                className="sui-text-lg"
              >
                {content}
              </Typography>
            </div>

            <div className="sui-flex sui-items-center sui-justify-center">
              {imageUrl && (
                <img
                  src={imageUrl}
                  alt={title}
                  width={96}
                  height={96}
                  className="sui-object-contain sui-h-24 sui-w-auto"
                />
              )}
            </div>

            <div className="sui-text-left sui-w-full sui-flex-1 sui-px-2 sui-pb-2">
              <Typography
                variant="body-lg"
                weight="bold"
                color="inverse"
                className="sui-mb-1"
              >
                Common products:
              </Typography>

              {commonProducts?.map((product, productIdx) => (
                <Typography
                  key={productIdx}
                  variant={productIdx === 0 ? 'body-base' : 'body-sm'}
                  color="inverse"
                  className={`sui-leading-snug  ${productIdx === 0 && commonProducts.length > 1 ? 'sui-mb-1' : ''}`}
                >
                  {product}
                </Typography>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="sui-grid sui-grid-cols-1 md:sui-grid-cols-3 sui-w-full sui-px-4 lg:sui-px-10 sui-gap-6">
        <div className="sui-flex sui-flex-row sui-gap-10 sm:sui-gap-4 md:sui-gap-8 lg:sui-gap-14 md:sui-justify-start">
          <img
            src={logoSrc}
            alt="Eco Actions Logo"
            width={60}
            height={60}
            className="sui-w-auto sui-h-8 sm:sui-h-10 md:sui-h-12 lg:sui-h-14 sui-flex-shrink-0"
          />
          <img
            src={qrSrc}
            alt="Eco Actions QR"
            width={60}
            height={60}
            className="sui-w-auto sui-h-8 sm:sui-h-10 md:sui-h-12 lg:sui-h-14 sui-flex-shrink-0"
          />
        </div>

        <div className="sui-col-span-1 md:sui-col-span-2 sui-flex sui-items-center sui-justify-start">
          <Typography variant="body-base" className="sui-leading-snug sui-text-base">
            The Home Depot&apos;s core values are based on doing the right thing
            for our associates and customers. Explore{' '}
            <Link
              href="https://ecoactions.homedepot.com/?emt=ppsms_recycling_2511"
              target="_blank"
              className="sui-underline"
            >
              Eco Actions
            </Link>{' '}
            at The Home Depot, where we are harnessing the power of the DIY
            movement to build a better world.
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default PPSMainRecycling;
